import React from "react";
import { formatNumber, formatPercent } from "~/utility/volby2026";

type Props = {
  processed: number;
  total: number;
  processedPct: number;
};

const ElectionProgressBar = ({ processed, total, processedPct }: Props) => {
  const pct = Math.max(0, Math.min(100, processedPct || 0));
  return (
    <div className="chart-row counted-graph-wrapper">
      <div className="chart-col full">
        <div className="chart-hdl">
          Spracovaných <b>{formatNumber(processed)}</b> z celkového počtu{" "}
          <b>{formatNumber(total)}</b> zápisníc | <b>{formatPercent(processedPct)}</b>
        </div>
        <div className="v26-progress">
          <div className="v26-progress-track">
            <div className="v26-progress-fill" style={{ width: pct + "%" }} />
          </div>
        </div>
      </div>
    </div>
  );
};

export default ElectionProgressBar;
